import { $, pageLoaded } from 'venuescanner-js/tools/elemental'
import { pageListener } from 'venuescanner-js/react/tracking/page_listener'
import { setupIntercom } from 'venuescanner-js/tools/loaders/intercom'
import { reviewsioSetup } from 'venuescanner-js/tools/loaders/reviewsio'
import { unbounceSetup } from 'venuescanner-js/tools/loaders/unbounce'

// import { inspectletSetup } from 'venuescanner-js/tools/loaders/inspectlet'
// import { sleeknoteSetup } from 'venuescanner-js/tools./loaders/sleeknote'
// import { setupHelpscout } from 'venuescanner-js/tools/loaders/helpscout'
// import {
//   urls,
//   endpoints,
//   absoluteEndpoints
// } from 'venuescanner-js/services/endPoints'
pageListener(window.data)

// console.log("Page load loaded")
pageLoaded(async () => {
  // methods to trigger on page load
  setTimeout(() => {
    setupIntercom()
    unbounceSetup()
    if ($('#ReviewsWidget').get().length) reviewsioSetup()
  }, 3000)
})
